<h2 mat-dialog-title>{{ data.title }}</h2>

<mat-dialog-content>
  @if (data.description) {
  <p class="description">{{ data.description }}</p>
  }

  <p class="list-label">{{ data.label }}</p>
  <mat-selection-list [(ngModel)]="selectedItems" class="selection-list">
    @for (item of data.items; track item) {
    <mat-list-option [value]="item" checkboxPosition="before" class="list-option">
      {{ getDisplayText(item) }}
    </mat-list-option>
    }
  </mat-selection-list>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button (click)="onCancel()">Cancel</button>
  <button mat-flat-button color="primary" (click)="onConfirm()" [disabled]="selectedItems.length === 0">
    {{ data.primaryButtonText || "Add" }}
  </button>
</mat-dialog-actions>
